export default "__VITE_ASSET__6bb76c73__"